import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',

    },
    {
      path: "/index",
      redirect: '/aa',
      name: 'index',
      component: () => import('../views/index.vue'),
      children: [
        // {
        //   path: '/a1',
        //   name: 'a1',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/b1',
        //   name: 'b1',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/c1',
        //   name: 'c1',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/d1',
        //   name: 'd1',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/a2',
        //   name: 'a2',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/b2',
        //   name: 'b2',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/c2',
        //   name: 'c2',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/d2',
        //   name: 'd2',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/a3',
        //   name: 'a3',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/b3',
        //   name: 'b3',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/c3',
        //   name: 'c3',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/d3',
        //   name: 'd3',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/a',
        //   name: 'a',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/b',
        //   name: 'b',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/c',
        //   name: 'c',
        //   component: ()=>import('../views/home.vue')
        // },
        // {
        //   path: '/d',
        //   name: 'd',
        //   component: ()=>import('../views/home.vue')
        // },//新服务器开始
        {
          path: '/aa',
          name: 'aa',
          component: () => import('../views/home.vue')
        },
        {
          path: '/bb',
          name: 'bb',
          component: () => import('../views/home.vue')
        },
        {
          path: '/cc',
          name: 'cc',
          component: () => import('../views/home.vue')
        },
        {
          path: '/dd',
          name: 'dd',
          component: () => import('../views/home.vue')
        },
        {
          path: '/e',
          name: 'e',
          component: () => import('../views/home.vue')
        },
        {
          path: '/f',
          name: 'f',
          component: () => import('../views/home.vue')
        },
        {
          path: '/g',
          name: 'g',
          component: () => import('../views/home.vue')
        },
        {
          path: '/h',
          name: 'h',
          component: () => import('../views/home.vue')
        },

        {
          path: '/i',
          name: 'i',
          component: () => import('../views/home.vue')
        },
        //特殊
        {
          path: '/j',
          name: 'j',
          component: () => import('../views/home.vue')
        },
        {
          path: '/k',
          name: 'k',
          component: () => import('../views/home.vue')
        },
        {
          path: '/l',
          name: 'l',
          component: () => import('../views/home.vue')
        },
        {
          path: '/m',
          name: 'm',
          component: () => import('../views/home.vue')
        },
        {
          path: '/jj',
          name: 'jj',
          component: () => import('../views/home.vue')
        },
        {
          path: '/kk',
          name: 'kk',
          component: () => import('../views/home.vue')
        },
        {
          path: '/ll',
          name: 'll',
          component: () => import('../views/home.vue')
        },
        {
          path: '/mm',
          name: 'mm',
          component: () => import('../views/home.vue')
        }, {
          path: '/jjj',
          name: 'jjj',
          component: () => import('../views/home.vue')
        },
        {
          path: '/kkk',
          name: 'kkk',
          component: () => import('../views/home.vue')
        },
        {
          path: '/lll',
          name: 'lll',
          component: () => import('../views/home.vue')
        },
        {
          path: '/mmm',
          name: 'mmm',
          component: () => import('../views/home.vue')
        },
        //区分页面title
        {
          path: '/n',
          name: 'n',
          component: () => import('../views/home.vue')
        },
        {
          path: '/o',
          name: 'o',
          component: () => import('../views/home.vue')
        },
        {
          path: '/p',
          name: 'p',
          component: () => import('../views/home.vue')
        },
        {
          path: '/q',
          name: 'q',
          component: () => import('../views/home.vue')
        },
        {
          path: '/r',
          name: 'r',
          component: () => import('../views/home.vue')
        },
        {
          path: '/s',
          name: 's',
          component: () => import('../views/home.vue')
        },
        {
          path: '/t',
          name: 't',
          component: () => import('../views/home.vue')
        },
        {
          path: '/u',
          name: 'u',
          component: () => import('../views/home.vue')
        },

        {
          path: '/v',
          name: 'v',
          component: () => import('../views/home.vue')
        },
        {
          path: '/w',
          name: 'w',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x',
          name: 'x',
          component: () => import('../views/home.vue')
        },

        {
          path: '/y',
          name: 'y',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z',
          name: 'z',
          component: () => import('../views/home.vue')
        },

        {
          path: '/s1',
          name: 's1',
          component: () => import('../views/home.vue')
        },
        {
          path: '/t1',
          name: 't1',
          component: () => import('../views/home.vue')
        },
        {
          path: '/u1',
          name: 'u1',
          component: () => import('../views/home.vue')
        },
        {
          path: '/v1',
          name: 'v1',
          component: () => import('../views/home.vue')
        },
        {
          path: '/w1',
          name: 'w1',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x1',
          name: 'x1',
          component: () => import('../views/home.vue')
        },
        {
          path: '/y1',
          name: 'y1',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z1',
          name: 'z1',
          component: () => import('../views/home.vue')
        },

        {
          path: '/s2',
          name: 's2',
          component: () => import('../views/home.vue')
        },
        {
          path: '/t2',
          name: 't2',
          component: () => import('../views/home.vue')
        },
        {
          path: '/u2',
          name: 'u2',
          component: () => import('../views/home.vue')
        },
        {
          path: '/v2',
          name: 'v2',
          component: () => import('../views/home.vue')
        },
        {
          path: '/w2',
          name: 'w2',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x2',
          name: 'x2',
          component: () => import('../views/home.vue')
        },
        {
          path: '/y2',
          name: 'y2',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z2',
          name: 'z2',
          component: () => import('../views/home.vue')
        },

        {
          path: '/w3',
          name: 'w3',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x3',
          name: 'x3',
          component: () => import('../views/home.vue')
        },
        {
          path: '/y3',
          name: 'y3',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z3',
          name: 'z3',
          component: () => import('../views/home.vue')
        },

        {
          path: '/w4',
          name: 'w4',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x4',
          name: 'x4',
          component: () => import('../views/home.vue')
        },
        {
          path: '/y4',
          name: 'y4',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z4',
          name: 'z4',
          component: () => import('../views/home.vue')
        },

        {
          path: '/w5',
          name: 'w5',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x5',
          name: 'x5',
          component: () => import('../views/home.vue')
        },
        {
          path: '/y5',
          name: 'y5',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z5',
          name: 'z5',
          component: () => import('../views/home.vue')
        },

        {
          path: '/w6',
          name: 'w6',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x6',
          name: 'x6',
          component: () => import('../views/home.vue')
        },
        {
          path: '/y6',
          name: 'y6',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z6',
          name: 'z6',
          component: () => import('../views/home.vue')
        },

        {
          path: '/w7',
          name: 'w7',
          component: () => import('../views/home.vue')
        },
        {
          path: '/x7',
          name: 'x7',
          component: () => import('../views/home.vue')
        },
        {
          path: '/y7',
          name: 'y7',
          component: () => import('../views/home.vue')
        },
        {
          path: '/z7',
          name: 'z7',
          component: () => import('../views/home.vue')
        },

        {
          path: '/w8',
          name: 'w8',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/x8',
          name: 'x8',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/y8',
          name: 'y8',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/z8',
          name: 'z8',
          component: () => import('../views/home.vue')
        },

        {
          path: '/w9',
          name: 'w9',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/x9',
          name: 'x9',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/y9',
          name: 'y9',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/z9',
          name: 'z9',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/w10',
          name: 'w10',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/x10',
          name: 'x10',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/y10',
          name: 'y10',  
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/z10',
          name: 'z10',
          component: () => import('../views/home.vue')
          },
        
        {
          path: '/w11',
          name: 'w11',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/x11',
          name: 'x11',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/y11',
          name: 'y11',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/z11',
          name: 'z11',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/w12',
          name: 'w12',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/x12',
          name: 'x12',
          component: () => import('../views/home.vue')
        },

        {
          path: '/y12',
          name: 'y12',
          component: () => import('../views/home.vue')
        },
        
        {
          path: '/z12',
          name: 'z12',
          component: () => import('../views/home.vue')
        },

        {
          path: '/profile',
          name: 'profile',
          component: () => import('../views/profile.vue')
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('../views/about.vue')
        }
      ]
    },

  ]
})

// router.beforeEach((to,from,next)=>{
//   console.log(from)
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js